// extracted by mini-css-extract-plugin
export default {"securedLink":"SecuredLink_securedLink__dtwwY","disabledLink":"SecuredLink_disabledLink__fCO3Z"};